/**
 * @generated SignedSource<<05034810228e42ac50faea2cb6423202>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_PRICE" | "FIXED_HOURS" | "TIME_AND_MATERIALS" | "%future added value";
export type PROGRAM_BUDGET_TYPE = "UNCAPPED" | "CAPPED" | "FIXED_PRICE" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectPortfolioPeriodDownload_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly currency: string | null;
    readonly programs: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly budgetType: PROGRAM_BUDGET_TYPE | null;
          readonly budgetValue: number | null;
          readonly totalAllocation: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly financialBasedProjects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly companyProjectId: number | null;
          readonly customProjectId: string | null;
          readonly name: string | null;
          readonly budgetType: BUDGET_TYPE | null;
          readonly budgetBaseCurrency: number | null;
          readonly defaultPeriodBudgetType: PERIOD_BUDGET_TYPE | null;
          readonly fullAccessToProject: boolean | null;
          readonly projectColor: string | null;
          readonly status: PROJECT_STATUS | null;
          readonly projectStartDay: number | null;
          readonly projectStartMonth: number | null;
          readonly projectStartYear: number | null;
          readonly projectEndDay: number | null;
          readonly projectEndMonth: number | null;
          readonly projectEndYear: number | null;
          readonly baselineWinChance: number | null;
          readonly priorityLevel: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly completion: number | null;
          readonly useBaseline: boolean | null;
          readonly rateCard: {
            readonly id: string;
            readonly name: string | null;
            readonly currency: string | null;
            readonly parentRateCardId: string | null;
          } | null;
          readonly client: {
            readonly id: string;
            readonly name: string;
            readonly logoId: string | null;
            readonly logoDefaultId: number | null;
          } | null;
          readonly projectLabels: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly label: {
                  readonly name: string | null;
                  readonly color: string | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly projectPersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly isContactPerson: boolean | null;
                readonly person: {
                  readonly id: string;
                  readonly fullName: string | null;
                  readonly firstName: string | null;
                  readonly lastName: string | null;
                  readonly profilePictureId: string | null;
                  readonly profilePictureDefaultId: number | null;
                  readonly initials: string | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly currentProjectStatus: {
            readonly id: string;
            readonly color: string | null;
            readonly description: string | null;
            readonly person: {
              readonly id: string;
              readonly firstName: string | null;
              readonly lastName: string | null;
              readonly fullName: string | null;
              readonly profilePictureId: string | null;
            } | null;
          } | null;
          readonly financialNumbers: {
            readonly billableActualTimeAndExpenses: number | null;
            readonly totalActualRevenueRecognition: number | null;
            readonly actualCost: number | null;
            readonly actualRevenueProfit: number | null;
            readonly actualRevenueMargin: number | null;
            readonly billablePlannedTimeAndExpenses: number | null;
            readonly plannedRevenue: number | null;
            readonly plannedCost: number | null;
            readonly plannedRevenueProfit: number | null;
            readonly plannedRevenueMargin: number | null;
            readonly billableForecastTimeAndExpensesToComplete: number | null;
            readonly totalForecastRevenueToComplete: number | null;
            readonly forecastCostToComplete: number | null;
            readonly forecastRevenueProfitToComplete: number | null;
            readonly forecastRevenueMarginToComplete: number | null;
            readonly billableTotalTimeAndExpensesAtCompletion: number | null;
            readonly nonBillableTotalTimeAndExpensesAtCompletion: number | null;
            readonly allTotalTimeAndExpensesAtCompletion: number | null;
            readonly totalRevenueRecognition: number | null;
            readonly totalCostAtCompletion: number | null;
            readonly totalRevenueProfitAtCompletion: number | null;
            readonly totalRevenueMarginAtCompletion: number | null;
            readonly baselineRevenue: number | null;
            readonly baselineTimeAndExpenses: number | null;
            readonly baselineCost: number | null;
            readonly baselineProfit: number | null;
            readonly baselineMargin: number | null;
            readonly baselineMinutes: number | null;
            readonly planVsBillableActualTimeAndExpenses: number | null;
            readonly planVsActualCost: number | null;
            readonly planVsActualRevenueProfit: number | null;
            readonly planVsActualRevenueRecognition: number | null;
            readonly planVsTotalRevenueAtCompletion: number | null;
            readonly planVsTotalBillableTimeAndExpensesAtCompletion: number | null;
            readonly planVsTotalCostAtCompletion: number | null;
            readonly planVsTotalRevenueProfitAtCompletion: number | null;
            readonly registeredMinutes: number | null;
            readonly forecastTimeToComplete: number | null;
            readonly totalTimeAtCompletion: number | null;
            readonly scopeApprovedMinutes: number | null;
            readonly invoiced: number | null;
            readonly paid: number | null;
            readonly accruedDeferred: number | null;
            readonly retainerPeriodTargetMinutes: number | null;
            readonly retainerPeriodTargetPrice: number | null;
            readonly recognitionLockedRevenue: number | null;
            readonly recognitionOpenRevenue: number | null;
            readonly projectedTotalRevenueVsProjectedTotalBillableValueOfService: number | null;
            readonly projectedTotalRevenueVsProjectedTotalValueOfService: number | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "ProjectPortfolioPeriodDownload_viewer";
};
export type ProjectPortfolioPeriodDownload_viewer$key = {
  readonly " $data"?: ProjectPortfolioPeriodDownload_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPortfolioPeriodDownload_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v3 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v4 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v5 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v6 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v7 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v8 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeOpportunityActuals"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "ignoreBaselineWinChance"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startYear"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPortfolioPeriodDownload_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectServiceProgramTypeConnection",
          "kind": "LinkedField",
          "name": "programs",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectServiceProgramTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProgramType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "budgetValue",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalAllocation",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "after",
              "variableName": "cursor"
            },
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            {
              "kind": "Variable",
              "name": "excludeOpportunityActuals",
              "variableName": "excludeOpportunityActuals"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "pageSize"
            },
            {
              "kind": "Variable",
              "name": "ignoreBaselineWinChance",
              "variableName": "ignoreBaselineWinChance"
            },
            {
              "kind": "Variable",
              "name": "searchQuery",
              "variableName": "searchQuery"
            },
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/)
          ],
          "concreteType": "ProjectTypeConnection",
          "kind": "LinkedField",
          "name": "financialBasedProjects",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyProjectId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "customProjectId",
                      "storageKey": null
                    },
                    (v9/*: any*/),
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "budgetBaseCurrency",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "defaultPeriodBudgetType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fullAccessToProject",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectColor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectStartDay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectStartMonth",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectStartYear",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectEndDay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectEndMonth",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectEndYear",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineWinChance",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PriorityLevel",
                      "kind": "LinkedField",
                      "name": "priorityLevel",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v9/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "completion",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "useBaseline",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RateCard",
                      "kind": "LinkedField",
                      "name": "rateCard",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v9/*: any*/),
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "parentRateCardId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Client",
                      "kind": "LinkedField",
                      "name": "client",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v9/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "logoId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "logoDefaultId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 1000
                        }
                      ],
                      "concreteType": "ProjectLabelTypeConnection",
                      "kind": "LinkedField",
                      "name": "projectLabels",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProjectLabelTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ProjectLabel",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Label",
                                  "kind": "LinkedField",
                                  "name": "label",
                                  "plural": false,
                                  "selections": [
                                    (v9/*: any*/),
                                    (v10/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "projectLabels(first:1000)"
                    },
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "contactsOnly",
                          "value": true
                        },
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 1000000
                        }
                      ],
                      "concreteType": "ProjectPersonTypeConnection",
                      "kind": "LinkedField",
                      "name": "projectPersons",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProjectPersonTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ProjectPerson",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "isContactPerson",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Person",
                                  "kind": "LinkedField",
                                  "name": "person",
                                  "plural": false,
                                  "selections": [
                                    (v0/*: any*/),
                                    (v11/*: any*/),
                                    (v12/*: any*/),
                                    (v13/*: any*/),
                                    (v14/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "profilePictureDefaultId",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "initials",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "projectPersons(contactsOnly:true,first:1000000)"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectStatus",
                      "kind": "LinkedField",
                      "name": "currentProjectStatus",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v10/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Person",
                          "kind": "LinkedField",
                          "name": "person",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v12/*: any*/),
                            (v13/*: any*/),
                            (v11/*: any*/),
                            (v14/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        (v3/*: any*/),
                        (v4/*: any*/),
                        (v5/*: any*/),
                        (v6/*: any*/),
                        (v7/*: any*/),
                        (v8/*: any*/)
                      ],
                      "concreteType": "FinancialNumbers",
                      "kind": "LinkedField",
                      "name": "financialNumbers",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "billableActualTimeAndExpenses",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalActualRevenueRecognition",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actualCost",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actualRevenueProfit",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actualRevenueMargin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "billablePlannedTimeAndExpenses",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedRevenue",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedCost",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedRevenueProfit",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedRevenueMargin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "billableForecastTimeAndExpensesToComplete",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalForecastRevenueToComplete",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastCostToComplete",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastRevenueProfitToComplete",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastRevenueMarginToComplete",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "billableTotalTimeAndExpensesAtCompletion",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "nonBillableTotalTimeAndExpensesAtCompletion",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "allTotalTimeAndExpensesAtCompletion",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalRevenueRecognition",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalCostAtCompletion",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalRevenueProfitAtCompletion",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalRevenueMarginAtCompletion",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "baselineRevenue",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "baselineTimeAndExpenses",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "baselineCost",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "baselineProfit",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "baselineMargin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "baselineMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "planVsBillableActualTimeAndExpenses",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "planVsActualCost",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "planVsActualRevenueProfit",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "planVsActualRevenueRecognition",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "planVsTotalRevenueAtCompletion",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "planVsTotalCostAtCompletion",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "planVsTotalRevenueProfitAtCompletion",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "registeredMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastTimeToComplete",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalTimeAtCompletion",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "scopeApprovedMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "invoiced",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "paid",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accruedDeferred",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "retainerPeriodTargetMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "retainerPeriodTargetPrice",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recognitionLockedRevenue",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recognitionOpenRevenue",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "projectedTotalRevenueVsProjectedTotalBillableValueOfService",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "projectedTotalRevenueVsProjectedTotalValueOfService",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "4df44194e41de497a7b2eb73f408e98f";

export default node;
